import React, { useEffect, useState } from 'react';
import { Download, Share, X } from 'lucide-react';
import { isStandalone, isIos } from '../lib/pwa';

let deferredPrompt = null;
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => { e.preventDefault(); deferredPrompt = e; window.dispatchEvent(new Event('pwa-installable')); });
  window.addEventListener('appinstalled', () => { deferredPrompt = null; window.dispatchEvent(new Event('pwa-installed')); });
}

export const InstallPwaButton = ({ appName, color = '#F59E0B', textColor = '#ffffff', className = '' }) => {
  const [canInstall, setCanInstall] = useState(!!deferredPrompt);
  const [showIosHelp, setShowIosHelp] = useState(false);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onInstallable = () => setCanInstall(true);
    const onInstalled = () => { setInstalled(true); setCanInstall(false); };
    window.addEventListener('pwa-installable', onInstallable);
    window.addEventListener('pwa-installed', onInstalled);
    return () => { window.removeEventListener('pwa-installable', onInstallable); window.removeEventListener('pwa-installed', onInstalled); };
  }, []);

  if (installed) return null;
  const ios = isIos();
  if (!canInstall && !ios) return null;

  const handleClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') deferredPrompt = null;
      setCanInstall(!!deferredPrompt);
      return;
    }
    if (ios) setShowIosHelp(true);
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        data-testid="install-pwa-btn"
        className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs sm:text-sm font-semibold transition-transform hover:scale-105 active:scale-95 ${className}`}
        style={{ backgroundColor: color, color: textColor }}
        title="Installer l'application sur votre appareil"
      >
        <Download className="w-4 h-4" />
        <span className="hidden sm:inline">Installer l'app</span>
        <span className="sm:hidden">App</span>
      </button>

      {showIosHelp && (
        <div className="fixed inset-0 z-[100] bg-black/60 flex items-end sm:items-center justify-center p-4" onClick={() => setShowIosHelp(false)} data-testid="ios-install-help">
          <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-start justify-between mb-3">
              <h3 className="font-bold text-gray-900 text-lg">Installer {appName || "l'application"}</h3>
              <button type="button" onClick={() => setShowIosHelp(false)} className="text-gray-400 hover:text-gray-600" aria-label="Fermer"><X className="w-5 h-5" /></button>
            </div>
            <ol className="text-sm text-gray-700 space-y-3">
              <li className="flex gap-3"><span className="font-bold" style={{ color }}>1.</span><span>Appuyez sur le bouton <Share className="inline w-4 h-4 mx-1" style={{ color }} /> <strong>Partager</strong> en bas de Safari.</span></li>
              <li className="flex gap-3"><span className="font-bold" style={{ color }}>2.</span><span>Choisissez <strong>« Sur l'écran d'accueil »</strong>.</span></li>
              <li className="flex gap-3"><span className="font-bold" style={{ color }}>3.</span><span>Appuyez sur <strong>Ajouter</strong>. L'application apparaîtra avec son icône.</span></li>
            </ol>
          </div>
        </div>
      )}
    </>
  );
};

export default InstallPwaButton;
